import React, { useEffect, useMemo, useState } from "react";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
  fetchPets,
  selectPet,
  selectPetNotif,
  selectTest,
} from "../../Testing/_redux/pets";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import {
  fetchPreviousTests,
  selectPreviousTest,
} from "../../Testing/_redux/previousTests";

import Modal from "react-modal";
import CustomModal from "../../../../_artifact/components/Modal";
import dateHelper from "../../../../_artifact/helpers/dateHelper";
import {
  fetchRewardPoints,
  selectPetRewards,
} from "../../Rewards/_redux/rewards";
import { translate } from "../../../../_artifact/i18n/Artifacti18n";
import config from "../../../config";
import { TestStatusTitles } from "../../Testing/pages/TesingUIHelper";
import { useAppUIContext } from "../../../AppUIContext";
import { fetchFaqs } from "../../Support/_redux/supports";
import { processFaqs } from "../../Support/pages/SupportUIHelper";
import { resetSelectedTrial } from "../../../utils";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "1.5rem 1rem",
    transform: "translate(-50%, -50%)",
  },
};

function Home({ intl, history }) {
  const appUIContext = useAppUIContext();
  const appUIProps = useMemo(() => {
    return {
      pets: appUIContext.pets,
      setPets: appUIContext.setPets,
      setReadReview: appUIContext.setReadReview,
      getReadReview: appUIContext.getReadReview,
      tab: appUIContext.tab,
      setTab: appUIContext.setTab,
      rejected: appUIContext.rejected,
      setRejected: appUIContext.setRejected,
    };
  }, [appUIContext]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const [badge, setBadge] = useState(0);
  const [questions, setQuestions] = useState(null);
  const [previousTests, setPreviousTests] = useState(null);
  const [isModalSubmittedOpen, setIsModalSubmittedOpen] = useState(false);

  const dispatch = useDispatch();
  const { state, panelist_details } = useSelector(
    (state) => ({
      state,
      panelist_details: state.pets.entities.panelist_details,
    }),
    shallowEqual
  );
  const {
    panelist_email_id: email,
    first_name,
    consent_flag: isConsent,
  } = state.auth.user;
  const { faqs } = state.supports.entities;

  const { entities, selectedPet, selectedPetNotif } = state.pets;
  const {
    entities: { rewardPoints },
    selectedPetRewards,
  } = state.rewards;
  const { panelist_pets, petNotifs } = entities;
  const [panelistCountry, setPanelistCountry] = useState(null);

  const {
    currentTestSchedule: currentTests,
    upcomingTestSchedule: upcomingTests,
  } = selectedPet;
  const previousTestsInStore = state.previousTests.entities;

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {}

  function closeModal() {
    setIsOpen(false);
  }

  const sortDescNewReview = (tests) => {
    tests.sort((a, b) => {
      if (a.new_review < b.new_review) return 1;
      if (a.new_review > b.new_review) return -1;
      return 0;
    });

    return tests;
  };
  useEffect(() => {
    const panelist_email = { panelist_email: email };
    dispatch(fetchPets(panelist_email));
    dispatch(fetchRewardPoints(panelist_email));
    dispatch(fetchFaqs());
    dispatch(selectTest(null));
    resetSelectedTrial();
    setIsModalSubmittedOpen(false);
  }, []);

  useEffect(() => {
    if (!previousTestsInStore) return;
    const tests = JSON.parse(JSON.stringify(previousTestsInStore));
    setPreviousTests(sortDescNewReview(tests));
  }, [previousTestsInStore]);

  // Selecting a pet on page load automatically.
  useEffect(() => {
    if (panelist_pets)
      if (panelist_pets.length > 0)
        if (!selectedPet.panelist_id) dispatch(selectPet(panelist_pets[0]));
        else {
          const panelist_pet = panelist_pets.find(
            ({ panelist_id }) => panelist_id === selectedPet.panelist_id
          );
          if (panelist_pet) dispatch(selectPet(panelist_pet));
          else dispatch(selectPet(panelist_pets[0]));
        }
  }, [panelist_pets]);

  useEffect(() => {
    if (rewardPoints) {
      const rewardPoint = rewardPoints.find(
        ({ panelist_id }) => panelist_id === selectedPet.panelist_id
      );
      dispatch(selectPetRewards(rewardPoint));
    }
  }, [selectedPet, rewardPoints]);

  useEffect(() => {
    const processedFaqs = processFaqs(faqs);
    setQuestions(processedFaqs?.filter((faq, index) => index < 2));
  }, [faqs]);

  // Opening notification popup
  useEffect(() => {
    if (previousTests) {
      setBadge(previousTests.filter(({ new_review }) => new_review > 0).length);
    }

    if (!petNotifs) {
      dispatch(selectPetNotif(null));
      closeModal();
      return;
    }

    const petNotif = petNotifs.find(
      (petNotif) => petNotif.panelist_id === selectedPet.panelist_id
    );

    if (!petNotif) {
      dispatch(selectPetNotif(null));
      closeModal();
      return;
    }
    dispatch(selectPetNotif(petNotif));

    const selectedPreviousTest = previousTests?.find(
      (previousTest) =>
        previousTest.test_schedule_id === petNotif.test_schedule_id
    );

    if (selectedPreviousTest)
      dispatch(selectPreviousTest(selectedPreviousTest));

    if (appUIProps.getReadReview(selectedPet.panelist_id)) return;
    openModal();
    appUIProps.setReadReview(selectedPet.panelist_id);
  }, [petNotifs, selectedPet, previousTests]);

  // Fetching previous tests
  useEffect(() => {
    if (selectedPet.panelist_id)
      dispatch(fetchPreviousTests({ panelist_id: selectedPet.panelist_id }));
  }, [appUIProps.tab, selectedPet]);

  useEffect(() => {
    if (panelist_details?.country) {
      setPanelistCountry(panelist_details.country);
    }
  }, [panelist_details, dispatch]);

  const greetings = () => {
    const date = dateHelper.now();
    if (
      date.getHours() >= config.morningHours &&
      date.getHours() < config.afternoonHours
    )
      return translate("APP.GREETINGS.GOOD_MORNING", intl);
    if (
      date.getHours() >= config.afternoonHours &&
      date.getHours() < config.eveningHours
    )
      return translate("APP.GREETINGS.GOOD_AFTERNOON", intl);
    return translate("APP.GREETINGS.GOOD_EVENING", intl);
  };

  const handleViewFeedback = () => {
    if (!selectedPetNotif) return;
    if (selectedPet.panelist_id)
      dispatch(fetchPreviousTests({ panelist_id: selectedPet.panelist_id }));
    closeModal();
    if (selectedPetNotif.review_count === 1) history.push("/testing/detail");
    else {
      appUIProps.setTab(config.tabs.previous);
      history.push("/testing");
    }
  };

  const handleViewTests = () => {
    appUIProps.setRejected(true);
    appUIProps.setTab(config.tabs.previous);
    history.push("/testing");
  };

  const handleTestClick = (test) => {
    if (
      test.species?.toLowerCase() === "cat" &&
      test?.test_type === "POST-TEST"
    ) {
      setIsModalSubmittedOpen(true);
    } else {
      dispatch(selectTest(test));
      const copyTest = { ...test };
      copyTest["panelist_id"] = selectedPet.panelist_id;
      copyTest["pet_name"] = selectedPet.pet_name;
      copyTest["species"] = selectedPet.species;
      const jsonString = JSON.stringify(copyTest);
      localStorage.setItem("preWeight", test.product_pre_wt);
      localStorage.setItem("selectedTest", jsonString);
      if (
        test.species?.toLowerCase() === "cat" &&
        test?.test_type === "POST-QUESTIONNAIRE"
      ) {
        history.replace("/testing/cameras/post");
      } else {
        history.replace("/testing/codes");
      }
    }
  };

  return (
    <>
      <div className="inner-page test-wrap">
        <h1>
          {greetings()}, {first_name}!
        </h1>
        <div className="pets-wrap-home">
          <h3>{translate("TESTING.GENERAL.YOUR_PET", intl)}</h3>
          <ul className="pet-lists">
            {panelist_pets?.map((pet, index) => (
              <li key={index}>
                <input
                  type="radio"
                  name="pet"
                  value=""
                  id={pet.panelist_id}
                  onChange={() => dispatch(selectPet(pet))}
                  checked={pet.panelist_id === selectedPet.panelist_id}
                />
                <label htmlFor={pet.panelist_id}>{pet.pet_name}</label>
                {pet.currentTestSchedule.length > 0 && (
                  <span className="badge danger">
                    {pet.currentTestSchedule.length}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="pets-dashboard">
          <div className="p-dashboard-left">
            {currentTests && currentTests.length > 0 && (
              <div className="p-upcoming-test">
                <h3 className="d-icon-title">
                  <i className="icon-test desktop-only"></i>{" "}
                  {translate("TESTING.GENERAL.CURRENT_TESTS", intl)}
                </h3>
                <ul className="test-lists live-test arrow">
                  {currentTests?.map((currentTest, index) => (
                    <li
                      key={index}
                      className="test-item"
                      onClick={() => handleTestClick(currentTest)}
                    >
                      <div className="test-image">
                        <img src="/assets/images/product.png" alt="" />
                      </div>
                      <div className="test-content">
                        <h4>{translate("APP.GREETINGS.TODAY", intl)}</h4>
                        <p>
                          {translate("TESTING.GENERAL.CODE", intl)}:{" "}
                          {currentTest.product_id}
                        </p>
                        <p>
                          {translate("TESTING.GENERAL.PRODUCT_WEIGHT", intl)}:{" "}
                          {currentTest.species.toLowerCase() === "cat"
                            ? currentTest.product_wt + " gms"
                            : currentTest.wt_offered + " gms"}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
                <hr />
              </div>
            )}
            <div className="p-previous-test">
              <Tabs
                selectedIndex={appUIProps.tab}
                onSelect={(tabIndex) => appUIProps.setTab(tabIndex)}
              >
                <TabList>
                  <Tab>{translate("TESTING.GENERAL.UPCOMING_TESTS", intl)}</Tab>
                  <Tab>
                    {translate("TESTING.GENERAL.PREVIOUS_TESTS", intl)}{" "}
                    {badge > 0 && <span className="badge danger">{badge}</span>}
                  </Tab>
                </TabList>
                <TabPanel>
                  <ul className="test-lists">
                    {upcomingTests?.map((upcomingTest, index) => (
                      <li key={index} className="test-item">
                        <div className="test-image">
                          <img src="/assets/images/product.png" alt="" />
                        </div>
                        <div className="test-content">
                          <h4>{upcomingTest.test_date}</h4>
                          <p>
                            {translate("TESTING.GENERAL.CODE", intl)}:{" "}
                            {upcomingTest.product_id}
                          </p>
                          <p>
                            {translate("TESTING.GENERAL.TEST", intl)}:{" "}
                            {upcomingTest.test_name}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                  {(!upcomingTests || upcomingTests.length === 0) && (
                    <div className="test-empty">
                      <div className="test-empty-message">
                        <img src="/assets/images/empty.svg" alt="empty" />
                        <p>
                          {translate("TESTING.GENERAL.NO_UPCOMING_TESTS", intl)}
                        </p>
                      </div>
                    </div>
                  )}
                </TabPanel>
                <TabPanel>
                  <ul className="test-lists arrow">
                    {previousTests?.map((previousTest, index) => (
                      <li
                        key={index}
                        className={`test-item ${
                          previousTest.new_review > 0 && "color-bg"
                        }`}
                        onClick={() => {
                          history.push("/testing/detail");
                          dispatch(selectPreviousTest(previousTest));
                        }}
                      >
                        <div className="test-image">
                          <img src="/assets/images/product.png" alt="" />
                        </div>
                        <div className="test-content">
                          <h4>
                            {previousTest.test_date}
                            {previousTest.score ===
                              TestStatusTitles.pending && (
                              <span className="test-status pending">
                                {translate("TESTING.GENERAL.PENDING", intl)}
                              </span>
                            )}
                            {previousTest.score ===
                              TestStatusTitles.approved && (
                              <span className="test-status success">
                                {translate("TESTING.GENERAL.APPROVED", intl)}
                              </span>
                            )}
                            {previousTest.score ===
                              TestStatusTitles.rejected && (
                              <span className="test-status rejected">
                                {translate("TESTING.GENERAL.REJECTED", intl)}
                              </span>
                            )}
                          </h4>
                          <p>
                            {translate("TESTING.GENERAL.CODE", intl)}:{" "}
                            {previousTest.product_id}
                          </p>
                          <p>
                            {translate("TESTING.GENERAL.TEST", intl)}:{" "}
                            {previousTest.test_name}
                          </p>
                          <p>
                            {translate("TESTING.GENERAL.COMMENT", intl)}:{" "}
                            <strong>{previousTest.feedback}</strong>
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                  {(!previousTests || previousTests.length === 0) && (
                    <div className="test-empty">
                      <div className="test-empty-message">
                        <img src="/assets/images/empty.svg" alt="empty" />
                        <p>
                          {translate("TESTING.GENERAL.NO_PREVIOUS_TESTS", intl)}
                        </p>
                      </div>
                    </div>
                  )}
                </TabPanel>
              </Tabs>
            </div>
          </div>
          <div className="p-dashboard-right desktop-only">
            {panelistCountry?.toLowerCase() === "usa" && (
              <div className="rewards-wrap">
                <h3 className="d-icon-title">
                  <i className="icon-rewards desktop-only"></i>{" "}
                  {translate("REWARDS.GENERAL.REWARDS", intl)}
                </h3>
                <div className="d-rewards">
                  <div className="d-rewards-first">
                    <label>
                      <div className="coins">
                        <img src="/assets/images/coin.svg" alt="" />
                        {translate("REWARDS.GENERAL.VIEW_REWARD", intl)}
                      </div>
                    </label>
                    <button
                      type="button"
                      className="btn btn-primary btn-block"
                      onClick={() =>
                        window.open("https://www.petfoodpoll.com", "_blank")
                      }
                    >
                      {translate("REWARDS.GENERAL.VIEW_REWARD", intl)}
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div className="support-wrap">
              <h3 className="d-icon-title">
                <i className="icon-support desktop-only"></i>{" "}
                {translate("SUPPORT.GENERAL.SUPPORT", intl)}
              </h3>
              <Tabs>
                <TabList>
                  {/* {panelistCountry?.toLowerCase() === "usa" && (
                    <Tab value="1">
                      {translate("SUPPORT.GENERAL.SUPPORT", intl)}
                    </Tab>
                  )} */}
                  {panelistCountry?.toLowerCase() === "mexico" && (
                    <Tab value="0">
                      {translate("SUPPORT.GENERAL.FAQ", intl)}
                    </Tab>
                  )}
                </TabList>
                {panelistCountry?.toLowerCase() === "mexico" && (
                  <TabPanel>
                    <div className="faq-wrap">
                      <Accordion allowZeroExpanded>
                        {questions?.map(({ header1, value1 }, index1) => (
                          <AccordionItem key={index1}>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                {header1}
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              {value1.map(({ header2, value2 }, index2) => (
                                <div key={index2}>
                                  <h4>{header2}</h4>
                                  <dl className="faq-questions">
                                    {value2.map(
                                      ({ question, response }, index) => (
                                        <div key={index}>
                                          <dt>{question}</dt>
                                          <dd>{response}</dd>
                                        </div>
                                      )
                                    )}
                                  </dl>

                                  {value1.length > index2 + 1 && <hr />}
                                </div>
                              ))}
                            </AccordionItemPanel>
                          </AccordionItem>
                        ))}
                      </Accordion>
                      <div className="see-all-faq">
                        <Link to="/support" className="link">
                          {translate("TESTING.BUTTON.VIEW_ALL", intl)}
                        </Link>
                      </div>
                    </div>
                  </TabPanel>
                )}
                <TabPanel>
                  <div className="vh-center">
                    {translate("APP.GENERAL.CONTACT", intl)}
                    <b>{translate("APP.SUPPORT.EMAIL", intl)}</b>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={isModalSubmittedOpen}
        action={translate("APP.BUTTON.OK", intl)}
        title={translate("TESTING.GENERAL.24_HOUR_TEXT", intl)}
        onClose={() => {
          setIsModalSubmittedOpen(false);
        }}
      />
      <Modal
        isOpen={modalIsOpen && isConsent === "Y"}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <button onClick={closeModal} className="close">
          <img src="/assets/images/icon-close.svg" alt="" />
        </button>
        {selectedPetNotif?.review_count > 1 && (
          <h4>
            {translate("TESTING.GENERAL.RECEIVED_REVIEWS", intl, {
              number: selectedPetNotif?.review_count,
            })}
          </h4>
        )}
        {selectedPetNotif?.review_count === 1 && (
          <h4>
            {translate("TESTING.GENERAL.YOUR_TEST_HAS_BEEN", intl)}{" "}
            {selectedPetNotif?.score === TestStatusTitles.approved && (
              <span style={{ color: "green" }}>
                {translate("TESTING.GENERAL.APPROVED", intl)}!
              </span>
            )}
            {selectedPetNotif?.score === TestStatusTitles.rejected && (
              <span style={{ color: "tomato" }}>
                {translate("TESTING.GENERAL.REJECTED", intl)}!
              </span>
            )}{" "}
            {translate("TESTING.GENERAL.CLICK_TO_VIEW_FEEDBACK", intl)}
          </h4>
        )}
        {selectedPetNotif?.review_count === 1 && (
          <p>{selectedPetNotif?.feedback}</p>
        )}

        <button
          className="btn btn-primary btn-block"
          onClick={handleViewFeedback}
        >
          {selectedPetNotif?.review_count === 1
            ? translate("TESTING.BUTTON.VIEW_FEEDBACK", intl)
            : translate("TESTING.BUTTON.VIEW_ALL", intl)}
        </button>
      </Modal>
    </>
  );
}

export default injectIntl(Home);
